
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { ConfigProvider } from "antd";
import '@ant-design/v5-patch-for-react-19';
import { themeProps } from "@alphascriptsolutions/client-core";
import "../styles/globals.css";

const rootElement: HTMLElement | null = document.getElementById("alphaEditPopup");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  root?.render(
    <ConfigProvider
      theme={{
        ...themeProps,
        token: {
          ...themeProps.token,
          fontSize: 13,
        },
      }}
    >
      <FluentProvider theme={webLightTheme}>
        <App />
      </FluentProvider>
    </ConfigProvider>
  );
});
